<template>
    <div class="video_modal_wrap" @click="handleClose">
        <div class="video_container" @click.stop>
            <div class="closeBtn" @click="handleClose">
                <img src="../../static/pc/close.png" alt="" />
            </div>
            <!-- 加载提示 -->
            <div v-if="isLoading" class="loading">
                <div class="loading_spinner"></div>
                <p>Loading...</p>
            </div>
            <video
                ref="videoPlayer"
                class="video_player"
                controls
                autoplay
                @loadeddata="isLoading = false"
                @waiting="isLoading = true"
                @playing="isLoading = false"
                @ended="handleVideoEnd"
            >
                <source :src="videoSrc" type="video/mp4">
                您的浏览器不支持视频播放
            </video>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        videoSrc: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isLoading: true
        }
    },
    mounted() {
        // 禁止页面滚动
        document.body.style.overflow = 'hidden';
    },
    beforeDestroy() {
        // 恢复页面滚动
        document.body.style.overflow = '';
        // 停止视频播放
        if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.pause();
        }
    },
    methods: {
        handleClose() {
            this.$emit('handleClose');
        },
        handleVideoEnd() {
            // 视频播放结束后可以自动关闭弹窗
            // this.handleClose();
        }
    }
}
</script>

<style scoped lang="less">
.video_modal_wrap {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;

    .video_container {
        position: relative;
        width: 80%;
        max-width: 1200px;
        background: #000;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);

        // 使用 padding-bottom 技巧保持 16:9 宽高比
        &::before {
            content: '';
            display: block;
            padding-bottom: 56.25%; // 16:9 = 9/16 = 56.25%
        }

        @media screen and (max-width: 768px) {
            width: 90%;
        }

        .closeBtn {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 40px;
            height: 40px;
            z-index: 10;
            cursor: pointer;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s;

            &:hover {
                background: rgba(0, 0, 0, 0.8);
                transform: scale(1.1);
            }

            img {
                width: 60%;
                height: 60%;
                object-fit: contain;
            }
        }

        .video_player {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: block;
            outline: none;
            background: #000; // 加载时显示黑色背景
        }

        .loading {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 5;
            text-align: center;
            color: #fff;

            .loading_spinner {
                width: 50px;
                height: 50px;
                border: 4px solid rgba(255, 255, 255, 0.3);
                border-top-color: #fff;
                border-radius: 50%;
                animation: spin 1s linear infinite;
                margin: 0 auto 15px;
            }

            p {
                font-size: 16px;
                margin: 0;
            }
        }
    }
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/VideoModal.vue